import * as React from 'react';
import { useTranslation } from 'react-i18next';
import type { DailyAggregate } from '@etiquetachef/types';
import { formatUsdCents, formatYyyymmddDisplay } from '../formatters';
import { BiTimeChart } from './BiTimeChart';

/**
 * Net New MRR diário em USD (`netNewMrr.netUsdCents`, único campo do agregado que pode ser
 * negativo — por isso barra, não linha). Centavos ÷ 100 no gráfico e reconvertidos no
 * `valueFormatter` (ver `MrrChart`).
 *
 * Origem: sem issue — commit 85642b993, 2026-05-04 15:56 +0200.
 * Usado por: `FinanceDashboardPage` (rota `/dashboard/finance`, `apps/admin`).
 *
 * Histórico:
 *  - 2026-10-10 14:40 +0200 — (#798) cabeçalho padrão (#796).
 */
export function NetNewMrrChart({
  series,
}: {
  series: readonly DailyAggregate[];
}): React.JSX.Element {
  const { t } = useTranslation();
  const data = series.map((d) => ({
    x: formatYyyymmddDisplay(d.yyyymmdd),
    y: d.netNewMrr.netUsdCents / 100,
  }));
  return (
    <BiTimeChart
      title={t('finance.charts.netNewMrr')}
      subtitle={t('finance.charts.usdAxis')}
      type="bar"
      data={data}
      color="#2563eb"
      valueFormatter={(v): string => formatUsdCents(Math.round(v * 100))}
    />
  );
}
